export function Keyword(value, object, fallback) {
    var _a, _b;
    return (_b = (_a = object[value]) !== null && _a !== void 0 ? _a : fallback) !== null && _b !== void 0 ? _b : object[Object.keys(object)[0]];
}
//# sourceMappingURL=keyword.js.map